// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, getDocs, addDoc, updateDoc, doc, query, orderBy, limit } from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCuQg6XTGQAMrdTj3d6tP_-aHgLOCt-TmE",
  authDomain: "rammirportfolio.firebaseapp.com",
  projectId: "rammirportfolio",
  storageBucket: "rammirportfolio.firebasestorage.app",
  messagingSenderId: "471591437644",
  appId: "1:471591437644:web:3cec68de4eb3034d3d3be9",
  measurementId: "G-P2WT5KE4S6"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db, collection, getDocs, addDoc, updateDoc, doc, query, orderBy, limit };